import axios from "axios";
import { SURVEY_BASE,SURVEY_BASE_DASHBOARD, EDIT_SURVEY_API, PUBLISH_SURVEY, DELETE_SURVEY_API, UPDATE_SURVEY_DATE_API, GET_REMIDNER_SETTING, CHECK_QUESTION_STATUS_API } from '../../constants/api';
import { SURVEY, MESSAGE_FOR_UPDATED, MESSAGE_FOR_CREATED, MESSAGE_FOR_PUBLISHED, MESSAGE_FOR_DELETED } from 'src/constants/NotificationMessageConstant';
import { ShowSuccessOrError, ShowException } from '../utils/tostar';
import { history } from 'src/store/config';

export const getSurveyListCall = () => {
    const resp = axios.get(SURVEY_BASE)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getSurveyListDashboardCall = () => {
    const resp = axios.get(SURVEY_BASE_DASHBOARD)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const saveSurveyCall = (data: any) => {
    const baseSurvey = data.payload.BaseSurvey;
    if (baseSurvey.id > 0) {
        const resp = axios.put(SURVEY_BASE, data.payload)
            .then((res: any) => {
                ShowSuccessOrError(SURVEY + MESSAGE_FOR_UPDATED, res);
                history.push("/surveys");
                return res;
            }).catch((err) => {
                ShowException(err);
                const responseError = { 'success': false }
                return responseError;
            });
        return resp;

    }
    else {
        const resp = axios.post(SURVEY_BASE, data.payload)
            .then((res: any) => {
                ShowSuccessOrError(SURVEY + MESSAGE_FOR_CREATED, res);
                history.push("/surveys");
                return res;
            }).catch((err) => {
                ShowException(err);
                const responseError = { 'success': false }
                return responseError;
            });
        return resp;
    }
}

export const editSurveyCall = (data: any) => {
    const resp = axios.get(EDIT_SURVEY_API + '?surveyId=' + data.payload)
        .then((res: any) => {
            return res;
        })
        .catch((err) => {
            ShowException(err);
        });
    return resp;
}

// check question status enable confirmation pop-up
export const getSurveyQuestionStatus = (data: any) => {
    const reqestPayload : any  = {
        "moduleIds": data.payload
    }
    const resp = axios.post(CHECK_QUESTION_STATUS_API, reqestPayload)
        .then((res: any) => {
            return res;
        })
        .catch((err : any) => {
            ShowException(err);
        });
    return resp;
}

export const publishSurveyCall = (data: any) => {
    const resp = axios.put(PUBLISH_SURVEY + "?surveyId=" + data.payload)
        .then((res: any) => {
            ShowSuccessOrError(SURVEY + MESSAGE_FOR_PUBLISHED, res);
            history.push("/surveys");
        }).catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const updateSurveyDateCall = (data: any) => {
    const resp = axios.put(UPDATE_SURVEY_DATE_API, data.payload)
        .then((res: any) => {
            ShowSuccessOrError(SURVEY + MESSAGE_FOR_UPDATED, res);
            history.push("/surveys");
        }).catch((err) => {
            ShowException(err);
        });
    return resp;
}
export const deleteSurveyCall = (data: any) => {
    const resp = axios.delete(DELETE_SURVEY_API + "?surveyId=" + data.payload)
        .then((res: any) => {
            ShowSuccessOrError(SURVEY + MESSAGE_FOR_DELETED, res);
        }).catch((err) => {
            ShowException(err);
        });
    return resp;
}

export const getEmailNotificationSettingCall = (surveyId: any) => {
    const resp = axios.get(GET_REMIDNER_SETTING + surveyId )
        .then((res: any) => {
            return res;
        }).catch((err) => {
            ShowException(err);
        });
    return resp;
}


// WEBPACK FOOTER //
// ./src/effects/api/api.survey.tsx